// IE 2026 10 13 / ODOO-5800 (вкладка «My signals»: клик по столбику / дольке должен фильтровать список, как пузырь): клик по столбику (сегменту стопки)
// или дольке круговой диаграммы вкладки Chart (AttrChart) ставит селекторы стола по измерению категории (ось X / категория дольки), у сегмента разрезной
// серии («мера::значение», series_dimension меры) — и по измерению серии (например, metric + grade). Тот же путь, что у пузыря в режиме dims:
// store-команда onApplySelector__Click по каналам fieldSelectors виджета (значения — action.selector_values вместо row.selector строк).
// Повторный клик по тому же кусочку (селекторы стоят ровно на его значениях) — селекторы снимаются. Прежняя форма расшифровки top-5 — по Shift+клику
// (и, как было, правой кнопкой). Только у виджета с fieldSelectors (условие пузыря canSelect в dims); без них, на телефоне, с Alt / Ctrl / Cmd,
// с опцией click-open-row — прежнее поведение. Флаг fe.ux.chartClickSelectors (дефолт ВКЛ). Чистая логика — юнит tests/unit/chartClickSelectors.test.mjs
export const CHART_CLICK_SEL_FLAG = 'fe.ux.chartClickSelectors'   // IE 2026 10 13 / ODOO-5800

export function chartClickSel_on(setting) {   // IE 2026 10 13 / ODOO-5800: чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(CHART_CLICK_SEL_FLAG, true) !== false : true } catch (e) { return true }
}

const _str = (v) => (v === null || v === undefined) ? '' : String(v)
const _empty = (v) => v === null || v === undefined || v === '' || v === '00000000-0000-0000-0000-000000000000'
const _DATE_X = new Set(['', 'date', 'date_parse'])
const _OTHERS = /^(Others|__others__|other)$/i

// каналы селектора виджета (doc.params.fieldSelectors) с binding
export function chartClickSel_selectors(fieldSelectors) {   // IE 2026 10 13 / ODOO-5800
    return Array.isArray(fieldSelectors) ? fieldSelectors.filter(f => f && typeof f === 'object' && _str(f.binding)) : []
}

// binding канала селектора для поля категории: само поле, либо его основа без «.title» / «_title» (подпись ссылки у дольки)
export function chartClickSel_match(binding, fieldSelectors) {   // IE 2026 10 13 / ODOO-5800
    const b = _str(binding)
    if (!b) return ''
    const have = new Set(chartClickSel_selectors(fieldSelectors).map(f => _str(f.binding)))
    for (const c of [b, b.replace(/\.title$/, ''), b.replace(/_title$/, '')]) if (c && have.has(c)) return c
    return ''
}

// цель клика: { values: { <binding канала>: значение }, key } | null (ни одно измерение кусочка не настроено каналом — прежнее поведение).
//   xKey — поле категории (axisX_bindingX2 столбиков / bindingName дольки; ось дат — не категория: дату ставит выбор периода, как было);
//   item — строка выборки кусочка; getValue(row, binding) — чтение значения (store.get_value);
//   seriesBinding / seriesDim — серия кусочка («мера::значение») и series_dimension её меры (разрезная серия → значение измерения серии; Others — не значение)
export function chartClickSel_target({ fieldSelectors, xKey, item, getValue, seriesBinding, seriesDim } = {}) {   // IE 2026 10 13 / ODOO-5800
    if (!item || typeof item !== 'object') return null
    const get = typeof getValue === 'function' ? getValue : (r, b) => r?.[b]
    const values = {}
    const xb = _DATE_X.has(_str(xKey)) ? '' : chartClickSel_match(xKey, fieldSelectors)
    if (xb) {
        let v
        try { v = get(item, xb) } catch (e) { v = undefined }
        if (!_empty(v) && typeof v !== 'object') values[xb] = v
    }
    const sb = _str(seriesBinding), i = sb.indexOf('::'), dim = _str(seriesDim)
    if (i > 0 && dim) {
        const key = sb.slice(i + 2), db = chartClickSel_match(dim, fieldSelectors)
        if (db && key && !_OTHERS.test(key)) values[db] = key
    }
    const keys = Object.keys(values)
    if (!keys.length) return null
    return { values, key: keys.sort().map(k => k + '=' + _str(values[k])).join('|') }
}

// IE 2026 10 13 / ODOO-5800 (бот на проде, ieSIGM_001: «клик → список позиций»): пузырь в режиме dims — цель клика: значения ВСЕХ каналов fieldSelectors
// у исходной строки точки (metric + grade); пустые значения пропускаются; ни одного — null (прежняя плашка)
export function chartClickSel_rowTarget({ fieldSelectors, item, getValue } = {}) {   // IE 2026 10 13 / ODOO-5800
    if (!item || typeof item !== 'object') return null
    const get = typeof getValue === 'function' ? getValue : (r, b) => r?.[b]
    const values = {}
    for (const fs of chartClickSel_selectors(fieldSelectors)) {
        let v
        try { v = get(item, fs.binding) } catch (e) { v = undefined }
        if (!_empty(v) && typeof v !== 'object') values[fs.binding] = v
    }
    const keys = Object.keys(values)
    if (!keys.length) return null
    return { values, key: keys.sort().map(k => k + '=' + _str(values[k])).join('|') }
}

// текущие значения селекторов стола по каналам виджета: { <binding>: [значения] } — чтение строк params.WHERE стола без правки
// (тот же поиск строки, что у store.get_rowWHERE: по condition у канала без leftValue, иначе по leftValue.value)
export function chartClickSel_current(fieldSelectors, WHERE) {   // IE 2026 10 13 / ODOO-5800
    const out = {}
    const rows = Array.isArray(WHERE) ? WHERE : []
    for (const fs of chartClickSel_selectors(fieldSelectors)) {
        const row = (fs.condition && !fs.leftValue)
            ? rows.find(w => w && w.condition === fs.condition)
            : rows.find(w => w && w.leftValue?.value === fs.leftValue?.value)
        out[fs.binding] = (row && row.use && Array.isArray(row.attrs)) ? row.attrs.filter(a => a && a.use !== false).map(a => a.rightValue?.value) : []
    }
    return out
}

// селекторы стоят ровно на значениях цели (повторный клик по тому же кусочку снимает их)
export function chartClickSel_isActive(target, current) {   // IE 2026 10 13 / ODOO-5800
    if (!target || !target.values) return false
    const keys = Object.keys(target.values)
    if (!keys.length) return false
    return keys.every(k => { const cur = (current || {})[k]; return Array.isArray(cur) && cur.length === 1 && _str(cur[0]) === _str(target.values[k]) })
}

// решение по клику: 'select' — поставить селекторы цели; 'clear' — снять селекторы виджета; 'drill' — прежний клик с формой расшифровки (Shift);
// 'legacy' — прежний клик как есть (флаг выкл / нет каналов / телефон / Alt, Ctrl, Cmd / click-open-row / мимо кусочка или кусочек без настроенного измерения)
export function chartClickSel_decide({ on = true, fieldSelectors, mobile = false, clickOpenRow = false, event, target, current } = {}) {   // IE 2026 10 13 / ODOO-5800
    if (!on || mobile || clickOpenRow || !chartClickSel_selectors(fieldSelectors).length) return 'legacy'
    const e = event || {}
    if (e.altKey || e.ctrlKey || e.metaKey) return 'legacy'
    if (e.shiftKey) return 'drill'
    if (!target) return 'legacy'
    return chartClickSel_isActive(target, current) ? 'clear' : 'select'
}
